import { Icon } from '@iconify/react';
import { Box } from '@mui/system';
import menuFill from '@iconify/icons-eva/menu-fill';
import { IconButton, Stack } from '@mui/material';
import NotificationsPopover from '../../layouts/dashboard/NotificationsPopover';
import AccountPopover from '../../layouts/dashboard/AccountPopover';

function Header({ isopensidebar, setOpen }) {
  return (
    <Box className="headerHolder">
      <Box>
        <IconButton
          sx={{ marginLeft: '-0.5rem' }}
          onClick={(e) => {
            if (isopensidebar === 'true') {
              setOpen(false);
              document.body.classList.add('sidebarOpen');
            } else {
              setOpen(true);
              document.body.classList.remove('sidebarOpen');
            }
          }}
        >
          <Icon icon={menuFill} width={30} height={30} />
        </IconButton>
      </Box>
      <Box>
        <Stack direction="row" alignItems="center">
          {/* <NotificationsPopover /> */}
          <img
            src="../../static/logos/realValueLogo.jpg"
            alt="Real Value Logo"
            className="loginLogo"
            style={{ height: '31px', width: '120px' }}
          />
          &nbsp;
          <AccountPopover />
        </Stack>
      </Box>
    </Box>
  );
}
export default Header;
